'use strict';
/*

    To use this input widget adapter you need to register it with your
    adapter registry.

*/

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import { createVNode, createComponentVNode, normalizeProps } from "inferno";
import { Component } from 'inferno';
import { Adapter } from 'component-registry';
import { interfaces } from 'isomorphic-schema';
import { IInputFieldWidget } from '../interfaces';
import { renderString } from './common';
import { generateId } from './utils';
import { Input } from 'inferno-bootstrap'; // Placeholder

var MultiSelectFieldWidget = /*#__PURE__*/function (_Component) {
  _inherits(MultiSelectFieldWidget, _Component);

  function MultiSelectFieldWidget(props) {
    var _this;

    _classCallCheck(this, MultiSelectFieldWidget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiSelectFieldWidget).call(this, props));
    _this.didGetChange = _this.didGetChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(MultiSelectFieldWidget, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "didGetChange",
    value: function didGetChange(e) {
      var field = this.props.adapter.context;
      var selectedOptions = e.target.selectedOptions;
      var values = [];

      for (var i = 0; i < selectedOptions.length; i++) {
        values.push(field.fromString(field.valueType.fromString(selectedOptions[i].value)));
      }

      this.props.onChange(this.props.propName, values);
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var inputName = _ref.inputName,
          namespace = _ref.namespace,
          options = _ref.options,
          doesNotRenderLabel = _ref.doesNotRenderLabel,
          id = _ref.id;
      var field = this.props.adapter.context;
      var isValid = this.props.validationError || this.props.invariantError ? false : undefined;
      var ariaLabels = {
        'aria-invalid': isValid !== undefined,
        'aria-labelledby': doesNotRenderLabel ? undefined : id,
        'aria-label': doesNotRenderLabel ? renderString(field.label || 'inferno-formlib--InputField', options && options.lang, 'MultiSelect Field') : undefined,
        'aria-required': field._isRequired ? field._isRequired : undefined
      };
      return normalizeProps(createComponentVNode(2, Input, _objectSpread({
        "type": "select",
        "id": generateId(namespace, '__Field'),
        "name": inputName
      }, ariaLabels, {
        "multiple": "true",
        "readOnly": field.readOnly,
        "value": field.valueType.toFormattedString(field.toFormattedString(this.props.value)),
        "valid": isValid,
        "onChange": this.didGetChange,
        children: [field.placeholder && createVNode(1, "option", null, renderString(field.placeholder, options && options.lang), 0, {
          "value": ""
        }), Array.isArray(field.options) && field.options.map(function (item) {
          return createVNode(1, "option", null, item.title, 0, {
            "value": item.name
          });
        })]
      })));
    }
  }]);

  return MultiSelectFieldWidget;
}(Component);

export default MultiSelectFieldWidget;
new Adapter({
  implements: IInputFieldWidget,
  adapts: interfaces.IMultiSelectField,
  Component: MultiSelectFieldWidget
});